import React, { useState } from 'react';
import { Image as ImageIcon, Loader2, Wand2 } from 'lucide-react';
import { removeWhiteBackground, readFileAsDataUrl } from '../lib/logoCleanup';

// value: { logo, logoOriginal, logoTransparent }
export function LogoUpload({ value, onChange, compact = false }) {
  const [busy, setBusy] = useState(false);
  const v = value || {};
  const original = v.logoOriginal || v.logo || '';

  const onFile = async (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    setBusy(true);
    try {
      const raw = await readFileAsDataUrl(f);
      const cleaned = await removeWhiteBackground(raw);
      onChange({ logo: cleaned, logoOriginal: raw, logoTransparent: true });
    } finally { setBusy(false); e.target.value = ''; }
  };

  const toggle = async (checked) => {
    if (!original) return;
    setBusy(true);
    try {
      const logo = checked ? await removeWhiteBackground(original) : original;
      onChange({ logo, logoOriginal: original, logoTransparent: checked });
    } finally { setBusy(false); }
  };

  return (
    <div className="space-y-1.5" data-testid="logo-upload">
      <div className="flex items-center gap-2">
        <div className={`${compact ? 'h-9 w-16' : 'h-12 w-24'} rounded border flex items-center justify-center overflow-hidden`} style={{ backgroundImage: 'linear-gradient(45deg,#e5e7eb 25%,transparent 25%,transparent 75%,#e5e7eb 75%),linear-gradient(45deg,#e5e7eb 25%,#fff 25%,#fff 75%,#e5e7eb 75%)', backgroundSize: '10px 10px', backgroundPosition: '0 0,5px 5px' }}>
          {busy ? <Loader2 className="w-4 h-4 animate-spin text-teal-600" /> : v.logo ? <img src={v.logo} alt="logo" className="max-h-full max-w-full object-contain p-0.5" data-testid="logo-preview" /> : <ImageIcon className="w-4 h-4 text-gray-300" />}
        </div>
        <label className="text-xs text-teal-700 cursor-pointer hover:underline" data-testid="logo-upload-input-label">{v.logo ? 'Change' : 'Upload logo'}<input type="file" accept="image/*" className="hidden" onChange={onFile} /></label>
        {v.logo && <button type="button" className="text-xs text-red-500" onClick={() => onChange({ logo: '', logoOriginal: '', logoTransparent: false })} data-testid="logo-remove-btn">Remove</button>}
      </div>
      {original && (
        <label className="flex items-center gap-1.5 text-[11px] text-gray-500 cursor-pointer select-none">
          <input type="checkbox" checked={!!v.logoTransparent} onChange={(e) => toggle(e.target.checked)} className="accent-teal-600" data-testid="logo-transparent-toggle" />
          <Wand2 className="w-3 h-3 text-teal-600" /> Transparent background (white removed)
        </label>
      )}
    </div>
  );
}
